/* eslint-disable no-unused-vars */
import { Grid, ThemeProvider } from "@mui/material";
import PDialog from "../../components/pos/PDialog";
import PText from "../../components/pos/PText";
import db from "../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import API from "../../utils/API";

export default function HoldCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [windowTitle, setWindowTitile] = useState(translate("Hold Sale"));

  const [noteError, setNoteError] = useState("");

  const [autoFocus, setAutoFocus] = useState(true);
  const [showCustomerLookup, setShowCustomerLookup] = useState(true);
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  useEffect(() => {
    if (props.customerBean) {
      setShowCustomerLookup(false);
      props.setCustomerBeanForHold({
        label: props.customerBean,
        value: props.customerBean,
      });
    }
  }, [props.customerBean]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function onCloseWindow() {
    props.setShowHoldWindow(false);
  }

  function getTargetTable() {}

  async function onPrint() {
    if (validate()) {
      props.onHold("Print");
    }
  }
  function onSave() {
    if (validate()) {
      props.onHold("Save");
    }
  }

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };
  async function getOptionsAsync(inputValue, callback) {
    let dbData = await db.customer
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("custId")
      .startsWithIgnoreCase(inputValue)
      .or("micrCode")
      .startsWithIgnoreCase(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      if (count < 10) {
        let val = {
          id: dbData[i].id,
          name: dbData[i].name,
          custId: dbData[i].custId,
          micrCode: dbData[i].micrCode,
          bean: dbData[i],
        };
        arr.push(val);
        count++;
      } else {
        break;
      }
    }

    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }
  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.custId}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.micrCode}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  function validate() {
    let flag = true;
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      //setLiveValidation(true);
    }
    return flag;
  }
  const customerLookupChanged = (newValue) => {
    props.setCustomerBeanForHold(newValue);
  };
  const content = (
    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
      <Grid container spacing={"10px"}>
        {showCustomerLookup && (
          <Grid item xs={12} sm={12}>
            <AsyncSelect
              formatOptionLabel={formatOptionLabel}
              autoFocus={autoFocus}
              onFocus={() => setAutoFocus(true)}
              blurInputOnSelect
              components={{ formatOptionLabel }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999,
                }),
                marginRight: "10px",
              }}
              placeholder={translate("Customer Lookup")}
              loadOptions={getOptions}
              onChange={customerLookupChanged}
              /*onKeyDown={(e) => {
          console.log("KEY");
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        }}*/
              value={props.customerBeanForHold}
            />
          </Grid>
        )}

        <Grid item xs={12} sm={12}>
          <PText
            placeholder={translate("Note")}
            multiLine={true}
            row={3}
            value={props.holdNote}
            error={noteError}
            onChange={(e) => props.setHoldNote(e.target.value)}
          ></PText>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      <PDialog
        content={content}
        title={windowTitle}
        maxWidth={"sm"}
        fullWidth={true}
        showPrint={true}
        onPrint={onPrint}
        open={true}
        onCloseWindow={onCloseWindow}
        onSave={onSave}
        mode={"create"}
        isDataChanged={isDataChanged}
      ></PDialog>
    </div>
  );
}
